<template>
  <div :id="`violation-${data.violationDeadlineCell.id}`" class="c-table-cell">
    <div class="c-table__cell-value">
      {{ data.violationDeadlineCell.deadline }}
      <a v-if="isFined" href="/?r=redesign#/fines-and-bonuses" target="_blank"> Штраф 100 ฿ </a>
    </div>

    <b-popover
      v-if="isFined"
      :target="`violation-${data.violationDeadlineCell.id}`"
      triggers="hover blur"
      placement="bottom"
      container="#app"
      custom-class="fine-tooltip"
    >
      Выписан штраф за отсутствие объяснительной в размере 100 ฿
    </b-popover>
  </div>
</template>

<script>
export default {
  name: "deadline-cell",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isFined() {
      return this.data.violationDeadlineCell.isFined;
    },
  },
};
</script>

<style lang="scss" scoped>
.c-table__cell-value {
  display: flex;
  flex-direction: column;
  & > a {
    white-space: nowrap;
  }
}
.fine-tooltip {
  max-width: 250px;
}
</style>
